import { Button } from 'antd';
import styled, { css } from 'styled-components';
import { media } from '../../responsive/media';

const toCssValue = (v) => (typeof v === 'number' ? `${v}px` : v);

export const ButtonStyled = styled(Button, (props) => props.className)`
  letter-spacing: 0px;
  height: ${({ $height }) => ($height ? toCssValue($height) : '40px')};
  width: ${({ $width }) => ($width ? toCssValue($width) : '120px')};
  font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 16)}px;
  font-weight: ${({ $fontWeight }) => $fontWeight || 'normal'} !important;
  border-color: ${({ $hoverData }) => $hoverData?.borderColor} !important;
  color: ${({ $hoverData }) => $hoverData?.borderColor} !important;
  ${({ $hoverData }) => {
    if ($hoverData) {
      return css`
        &:hover {
          background-color: ${$hoverData.backgroundColor} !important;
          color: ${$hoverData.color} !important;
          border-color: ${$hoverData.borderColor} !important;
        }
      `;
    }
  }}
  &:hover {
    opacity: 0.8;
  }

  ${({ $btnType }) => {
    switch ($btnType) {
      case 'primary':
        return css`
          background-color: #ed7836;
          border-color: #ed7836;
          color: #fff;
        `;
      case 'outline':
        return css`
          background-color: transparent;
          border-color: #ed7836;
          color: #ed7836;
          &:hover {
            background-color: #ed7836;
            opacity: 1;
            color: #fff;
          }
        `;
      case 'secondary':
        return css`
          background-color: #ed7836;
          border-color: #d9d9d9;
          color: #000000d9;
        `;
      case 'auth-back':
        return css`
          border: 1px solid #d9d9d9;
          color: #595959;
          min-width: 100% !important;
        `;
      case 'back':
        return css`
          background-color: transparent !important;
          border: 1px solid #e6ebf1 !important;
          color: #595959 !important;
        `;
      case 'disabled':
        return css`
          background-color: transparent !important;
          border: 1px solid #e6ebf1 !important;
          color: #595959 !important;
          cursor: not-allowed !important;
        `;
    }
  }}

  /* ========= Responsive ========= */
  ${media.xxlDown(css`
    height: ${({ $height }) => ($height ? `${$height * 0.9}px` : '36px')};
    width: ${({ $width }) => ($width ? `${$width * 0.9}px` : '96px')};
    border-radius: 8px;
  `)}

  ${media.xlDown(css`
    height: ${({ $height }) => ($height ? `${$height * 0.8}px` : '32px')};
    width: ${({ $width }) => ($width ? `${$width * 0.8}px` : '80px')};
    border-radius: 6px;
  `)}
`;
